var logo = {
  "dlsLogoBlueboxSolidXs": {
    "display": "inline-block",
    "width": "36px",
    "height": "36px"
  },
  "dlsLogoBlueboxSolidXs_img": {
    "width": "100%"
  },
  "dlsLogoBlueboxSolidSm": {
    "display": "inline-block",
    "width": "45px",
    "height": "45px"
  },
  "dlsLogoBlueboxSolidSm_img": {
    "width": "100%"
  },
  "dlsLogoBlueboxSolidMd": {
    "display": "inline-block",
    "width": "50px",
    "height": "50px"
  },
  "dlsLogoBlueboxSolidMd_img": {
    "width": "100%"
  },
  "dlsLogoBlueboxSolidLg": {
    "display": "inline-block",
    "width": "60px",
    "height": "60px"
  },
  "dlsLogoBlueboxSolidLg_img": {
    "width": "100%"
  },
  "dlsLogoBlueboxAltXs": {
    "display": "inline-block",
    "width": "36px",
    "height": "36px"
  },
  "dlsLogoBlueboxAltXs_img": {
    "width": "100%"
  },
  "dlsLogoBlueboxAltSm": {
    "display": "inline-block",
    "width": "45px",
    "height": "45px"
  },
  "dlsLogoBlueboxAltSm_img": {
    "width": "100%"
  },
  "dlsLogoBlueboxAltMd": {
    "display": "inline-block",
    "width": "50px",
    "height": "50px"
  },
  "dlsLogoBlueboxAltMd_img": {
    "width": "100%"
  },
  "dlsLogoBlueboxAltLg": {
    "display": "inline-block",
    "width": "60px",
    "height": "60px"
  },
  "dlsLogoBlueboxAltLg_img": {
    "width": "100%"
  },
  "dlsLogoLineXs": {
    "display": "inline-block",
    "width": "140px",
    "height": "9px"
  },
  "dlsLogoLineXs_img": {
    "width": "100%"
  },
  "dlsLogoLineSm": {
    "display": "inline-block",
    "width": "235px",
    "height": "15px"
  },
  "dlsLogoLineSm_img": {
    "width": "100%"
  },
  "dlsLogoLineMd": {
    "display": "inline-block",
    "width": "280px",
    "height": "18px"
  },
  "dlsLogoLineMd_img": {
    "width": "100%"
  },
  "dlsLogoLineLg": {
    "display": "inline-block",
    "width": "364px",
    "height": "24px"
  },
  "dlsLogoLineLg_img": {
    "width": "100%"
  },
  "dlsLogoStackXs": {
    "display": "inline-block",
    "width": "90px",
    "height": "25px"
  },
  "dlsLogoStackXs_img": {
    "width": "100%"
  },
  "dlsLogoStackSm": {
    "display": "inline-block",
    "width": "100px",
    "height": "28px"
  },
  "dlsLogoStackSm_img": {
    "width": "100%"
  },
  "dlsLogoStackMd": {
    "display": "inline-block",
    "width": "115px",
    "height": "31px"
  },
  "dlsLogoStackMd_img": {
    "width": "100%"
  },
  "dlsLogoStackLg": {
    "display": "inline-block",
    "width": "150px",
    "height": "41px"
  },
  "dlsLogoStackLg_img": {
    "width": "100%"
  }
};

export default logo;
